module.exports = __webpack_public_path__ + "img/google.40237688.png";